import { getShipsData } from "../sessionStorage/getShipsData";

export default function getShipImageByCode(shipCode) {
  const ships = getShipsData()
  const selectedShip = ships.find(ship => ship.ship_code === shipCode)
  const shipImage = selectedShip && selectedShip.image && selectedShip.image[0]
  
  return shipImage
}